module.exports = __webpack_public_path__ + "static/media/logopng.a9a8c057.png";